import {
  getSingleJob,
  getRoundDetails,
  getVendorCandidates,
  getCustomerFields,
  getVendorJd,
  requestDocuments,
  getPassFailCands,
  getNotes,
} from "../../utils/apiFunctions";
import Applied from "../../components/Kanban/Applied.vue";
import Qualified from "../../components/Kanban/Qualified.vue";
import KanbanRejected from "../../components/Kanban/KanbanRejected.vue";
import AddedtoJd from "../../components/Kanban/AddedtoJD.vue";
import Assessment from "../../components/Kanban/Assessment.vue";
import FacetoFace from "../../components/Kanban/FacetoFace.vue";
import Rejected from "../../components/Kanban/Rejected.vue";
import Selected from "../../components/Kanban/Selected.vue";
import Onhold from "../../components/Kanban/Onhold.vue";
import NotInterested from "../../components/Kanban/Notinterested.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import TriggerAssessment from "../../components/Kanban/modal/triggerAssessment.vue";
import SmallSpinner from "../../components/fixedcomponents/SmallSpinner.vue";
import ScheduleInterview from "../../components/Kanban/modal/scheduleInterview.vue";
import NotInterestedModal from "../../components/Kanban/modal/NotInterested.vue";
import GiveFeedBack from "../../components/Kanban/modal/GiveFeedBack.vue";
import SharedtoClient from "../../components/Kanban/SharetoClient.vue";
import AddFromTalentPool from "../../components/Kanban/modal/addfromTalentPool";
import AddMultipleExcelModal from "../../controllers/vendorCode/modals/AddMultipleExcelModal.vue";
import TriggerMultipleAssessment from "../../components/Kanban/modal/TriggerMultipleAssessment.vue";
import PreviewCandidateSidebar from "../../controllers/JD/modals/PreviewCandidateSidebar.vue";
import FeedbackHistory from "../Kanban/modal/FeedbackHistory.vue";
import ActionModal from "../../components/Kanban/modal/ActionModal.vue";
import ShareToClientModal from "../../components/Kanban/modal/ShareToClientModal.vue";
import CancelMeetingModal from "../../components/Kanban/modal/CancelMeetingModal.vue";
import Sourcemulti from "../../components/fixedcomponents/TalentPool/Source.vue";
import AssessmentExpiredModal from "../../components/Kanban/modal/AssessmentExpiredModal.vue";
import MoveToFinal from "../../components/Kanban/modal/MoveToFinal.vue";
import AddAttachment from "../../components/Kanban/modal/AddAttachmentModal.vue";
import AddNote from "../../components/Kanban/modal/AddNoteModal.vue";
import FormTags from "../../components/InputComponents/FormTags";
import DateField from "../../components/InputComponents/DateField";
import AlreadyInterviewed from "../../components/Kanban/modal/AlreadyInterviewed.vue";
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
// import { DateTime } from "luxon";
import { formatYearsDate } from "../../controllers/commonHelpers";
import MultiSearch from "../../components/InputComponents/MultiSearch.vue";

import { mapGetters } from "vuex";
import toast from "./toast";
const kanbanData = {
  name: "KanbanMixin",
  data() {
    return {
      fromAction: false,
      inAddedToJd: false,
      uploadingResume: false,
      showAlreadyInterview: false,
      showAttachmentInNote: false,
      showElement: false,
      jobAnalytics: false,
      applyContainers: false,
      showAddNote: false,
      showAddAttachment: false,
      showNoteTag: false,
      shareType: null,
      showExpired: false,
      isFilter: false,
      vendor: false,
      showShareToClient: false,
      showTalentPool: false,
      loaderStatus: false,
      trigger: false,
      isSchedule: false,
      isMoveToFinal: false,
      isNotInterested: false,
      isReassign: false,
      isGiveFeedback: false,
      addMultipleCandidates: false,
      checkMultiple: false,
      openExcelModal: false,
      viewCandidateModal: false,
      openReportTab: false,
      showJobSpinner: false,
      showHistoryModal: false,
      showCancelMeeting: false,
      actionModal: false,
      filterApplied: false,
      showUniqueFilters: false,
      showBlur: false,
      jobPageEnd: null,
      jobTotal: null,
      vendorRounds: null,
      jobPage: 0,
      showMultiTrigger: false,
      toRound: null,
      recRemarks: null,
      totalPushed: null,
      hoverCand: null,
      noteTagData: {},
      scheduleType: "",
      selectedID: "",
      level: "",
      viewCandID: "",
      particularJob: {},
      roundDetails: {},
      uniqueFilter: {},
      loadedPages: {},
      from: {
        level: null,
        index: null,
      },
      selectedCandidate: {},
      selectedProcess: {},
      storeUniqueValues: [],
      filterTestID: [],
      filterDate: [],
      shareCandidate: {},
      interviewProcess: [],
      showLoader: [],
      jobCards: [],
      customFieldsArray: [],
      storeFilterSource: [],
      storeFilterSkills: [],
      storeFilterAddedBy: [],
      storeFilterPositionID: [],
      storeFilterDate: [],
      storeFilterTags: [],
      storeCvsStatus: null,
      pages: [],
      totals: [],
      spinners: [],
      topSpinners: [],
      pageEnds: [],
      notesTags: [],
      filterObject: {
        filterSource: [],
        skillSets: [],
        createdByUserName: [],
        positionID: [],
        selectedDate: [],
        cvsStatus: null,
        tags: [],
      },
      assessfilteroptions: [
        { label: "All", key: "0" },
        { label: "Not Triggered", key: "1" },
        { label: "Not yet Started", key: "2" },
        { label: "Ongoing", key: "3" },
        { label: "Completed", key: "4" },
        { label: "Pass", key: "5" },
        { label: "Fail", key: "6" },
        { label: "No Show", key: "DNA" },
      ],
      f2ffilteroptions: [
        { label: "All", key: "0" },
        { label: "Scheduled", key: "true" },
        { label: "Not Scheduled", key: "false" },
        { label: "No Show", key: "DNA" },
      ],
      statusFilterOptions: [
        { label: "All", key: "0" },
        { label: "Selected", key: "SELECTED" },
        { label: "Offer Issued", key: "OFFER" },
        { label: "Onboarded", key: "ONBOARD" },
      ],
    };
  },
  async created() {
    await this.loadAllData();
  },
  components: {
    Applied,
    Qualified,
    KanbanRejected,
    AddedtoJd,
    Assessment,
    FacetoFace,
    Rejected,
    Selected,
    Onhold,
    NotInterested,
    Spinner,
    SmallSpinner,
    TriggerAssessment,
    ScheduleInterview,
    NotInterestedModal,
    GiveFeedBack,
    SharedtoClient,
    AddFromTalentPool,
    AddMultipleExcelModal,
    TriggerMultipleAssessment,
    PreviewCandidateSidebar,
    FeedbackHistory,
    ActionModal,
    ShareToClientModal,
    CancelMeetingModal,
    Sourcemulti,
    AssessmentExpiredModal,
    MoveToFinal,
    AddAttachment,
    AddNote,
    FormTags,
    AlreadyInterviewed,
    DateField,
    SelectCustom,
    MultiSearch,
  },
  computed: {
    getJobNotFoundText() {
      let text;
      let jobStatus = this.particularJob.status;
      if (!this.particularJob.active)
        text = "This job is no longer available since it has been deleted.";
      else if (jobStatus == 4) text = "This job has been rejected.";
      else if (this.particularJob.closed)
        text = "This job is no longer available since it has been closed.";
      else text = "This job has not been approved.";
      return text;
    },
    getInterviewProcess() {
      if (this.vendor && this.vendorRounds == 0) {
        return this.interviewProcess.filter(
          (obj) => obj.id == 0 || obj.id == "P" || obj.id == "NI"
        );
      } else {
        return this.interviewProcess;
      }
    },
    disableApplyFilter() {
      if (!this.vendor) {
        if (
          this.filterObject.filterSource.length == 0 &&
          this.filterObject.skillSets.length == 0 &&
          this.filterObject.createdByUserName.length == 0 &&
          this.filterObject.positionID.length == 0 &&
          this.filterObject.selectedDate.length == 0 &&
          this.filterObject.tags.length == 0 &&
          this.filterObject.cvsStatus == null
        ) {
          return true;
        }
      } else {
        if (
          this.filterObject.filterSource.length == 0 &&
          this.filterObject.skillSets.length == 0 &&
          this.filterObject.selectedDate.length == 0 &&
          this.filterObject.createdByUserName.length == 0
        ) {
          return true;
        }
      }
      return false;
    },
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
      roleValues: "getRoleValues",
    }),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
      storedSelectedCandidate: "getSelectedCandidate",
      storedSelectedProcess: "getSelectedProcess",
    }),
  },
  watch: {
    $route(to, from) {
      if (to.query !== from.query) {
        this.loadAllData();
      }
    },
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader" && this.checkValue(newValue)) {
          this.loaderStatus = true;
          this.applPage = 0;
          this.loadedPages = {};
          this.getParticularJob(this.$route.query.jobID);
          if (!this.vendor) this.getAllApplications(true);
        }
      }
    },
  },
  mixins: [toast],
  mounted() {
    // Attach a click event listener to the document body for handling clicks outside filter menus
    document.body.addEventListener("mousedown", this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove the click event listener when the component is destroyed
    document.body.removeEventListener("mousedown", this.handleClickOutside);
  },
  methods: {
    // getUTCDate(dateRange) {
    //   return dateRange.map((date) =>
    //     DateTime.fromISO(date, { zone: "local" }).toUTC().toFormat("yyyy-MM-dd")
    //   );
    // },
    async loadAllData() {
      this.loaderStatus = true;
      this.vendor = this.$route.name == "VendorKanban" ? true : false;
      await this.getParticularJob(this.$route.query.jobID);
      if (
        this.particularJob.status == 3 &&
        !this.particularJob.closed &&
        this.particularJob.active
      ) {
        if (this.storedSelectedCandidate) {
          if (this.$route.query.preview || this.$route.query.history) {
            this.viewCandidate(this.storedSelectedCandidate.candidate);
          } else if (this.$route.query.givefeed) {
            this.giveFeedbackModal(
              this.storedSelectedCandidate,
              this.storedSelectedProcess
            );
          } else if (this.$route.query.feedbackModal) {
            this.openHistoryModal(this.storedSelectedCandidate);
          }
        }
        if (!this.$route.query.history) {
          this.$store.commit("jobDescriptionVUEX/setSelectedCandidate", "");
          this.$store.commit("jobDescriptionVUEX/setSelectedProcess", "");
        }
        await this.getCustomField();
        this.$store.commit("searchVUEX/saveSearchQuery", "");
        if (this.vendor) {
          await this.getVendorJobs();
        } else {
          await this.getJobs();
          await this.getCreditsInfo();
        }
        this.setPositionIDs();
      }
    },
    getSingleRowData(candidate) {
      if (candidate.kanbanLevel == 0) {
        let type;
        if (
          candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].rejectedByAI
        ) {
          type = "RAI";
        } else type = "QA";
        if (!this.viewCandidateModal)
          this.applicationData[type].applSpinner = true;
        this.applicationData[type].applPage = 0;
        this.getCandidatesData(type);
      } else {
        let index = this.interviewProcess.findIndex(
          (item) => item.id == candidate.kanbanLevel
        );
        if (!this.viewCandidateModal) this.showLoader[index] = true;
        this.pages[index] = 0;
        this.getCandidates(candidate.kanbanLevel, index);
      }
    },
    setNoteTags(candidate) {
      this.noteTagData = {
        type: "add",
        tags: candidate.customFields?.notesTags
          ? candidate.customFields.notesTags
          : [],
      };
    },
    showBlurCand(value, cand) {
      if (value) this.hoverCand = cand.email;
      else this.hoverCand = null;
      this.showBlur = value;
    },
    async getNotes() {
      let payload = {
        jobID: this.particularJob.jobID,
        tags: true,
      };
      const res = await getNotes(payload);
      if (res.status == 200) {
        this.notesTags = res.data.data.tags;
        // if(this.notesTags.length != 0){
        //   this.notesTags = this.notesTags.map(item => ({ value: item, text: item }));
        // }
      }
    },
    async getPassFailCands(process) {
      let emails = [];
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          level: parseInt(process.id),
        };
        const res = await getPassFailCands(payload);
        if (res.status == 200) {
          emails =
            this.uniqueFilter[process.id].filterType == "5"
              ? res.data.data.passed
              : res.data.data.failed;
        }
        return emails;
      } catch (error) {
        console.error(error);
        return emails;
      }
    },
    testData(process) {
      let filteredTests = [];
      process.selectedtests.map((obj) => {
        filteredTests.push({ key: obj.testID, label: obj.name });
      });
      return filteredTests;
    },
    closeAlreadyModal(value) {
      if (value) {
        if (!this.vendor) this.getAllApplications(true);
        this.getParticularJob(this.particularJob.jobID);
        this.closeScheduleModal();
        this.closeTriggerModal();
      }
      this.showAlreadyInterview = false;
    },
    checkValue(val) {
      if (this.isSchedule) {
        return val.length != 0;
      }
      return true;
    },
    async requestDocs(candidate) {
      try {
        let payload = {
          candidateID: candidate.candidateID,
          jobID: this.particularJob.jobID,
        };
        const res = await requestDocuments(payload);
        if (res.status == 200) {
          this.dynamicToast(
            "success",
            `Successfully requested`,
            "Documents requested successfully"
          );
        } else {
          this.errorModal(res.data.data.Detail);
        }
        this.selCandidate();
      } catch (err) {
        this.errorModal("Something went wrong");
      }
    },
    getAssessFilterOptions(level) {
      if (level === 1) {
        return this.assessfilteroptions.filter((obj) => obj.key != "1");
      }
      return this.assessfilteroptions;
    },
    scheduleFilterOptions(level) {
      if (level === 1) {
        return this.f2ffilteroptions.filter((obj) => obj.key != "false");
      }
      return this.f2ffilteroptions;
    },
    getFilterOptions(process) {
      if (process.type == "assesment")
        return this.getAssessFilterOptions(process.id);
      else return this.scheduleFilterOptions(process.id);
    },
    isAsmntIcon(process, index) {
      if (
        (process.id != "F" &&
          process.id != "P" &&
          process.id != "NI" &&
          process.id != "H" &&
          process.id != "R" &&
          process.type != "f2f" &&
          this.checkRoundAssessment(index)) ||
        (process.id == 0 && this.checkRoundAssessment(index + 1))
      ) {
        return true;
      } else {
        return false;
      }
    },
    isFilterIcon(process) {
      if (
        process.id != "P" &&
        process.id != "NI" &&
        process.id != "H" &&
        process.id != "R" &&
        process.id != 0
      ) {
        return true;
      }
      return false;
    },
    checkMutiAssessTrigger(process) {
      return (
        this.roundDetails[`round${process.id}`] &&
        this.roundDetails[`round${process.id}`]["candidates"].length != 0
      );
    },
    async clearfilter(flag, jobID) {
      this.applyflag = flag;
      this.filterApplied = false;
      this.isFilter = false;
      this.filterObject = {
        filterSource: [],
        skillSets: [],
        createdByUserName: [],
        positionID: [],
        selectedDate: [],
        cvsStatus: null,
        tags: [],
      };
      if (this.applyflag) {
        this.currentPage = 1;
        this.storeFilterSource = [];
        this.storeFilterSkills = [];
        this.storeFilterAddedBy = [];
        this.storeFilterPositionID = [];
        this.storeFilterDate = [];
        this.storeCvsStatus = null;
        this.storeFilterTags = [];
        let jobId = jobID ? jobID : this.particularJob.jobID;
        await this.getParticularJob(jobId);
        if (!this.vendor) {
          await this.getAllApplications(true);
          // await this.getCreditsInfo();
        }
      }
      this.applyflag = false;
    },
    async applyTalentFilterTest() {
      this.LoaderStatus = true;
      this.filterApplied = false;
      this.isFilter = false;
      if (!this.vendor) this.getAllApplications(true);
      await this.getParticularJob(this.particularJob.jobID);

      this.storeFilterSource = this.filterObject.filterSource;
      this.storeFilterSkills = this.filterObject.skillSets;
      this.storeFilterAddedBy = this.filterObject.createdByUserName;
      this.storeFilterPositionID = this.filterObject.positionID;
      this.storeCvsStatus = this.filterObject.cvsStatus;
      this.storeFilterDate = this.filterObject.selectedDate;
      this.storeFilterTags = this.filterObject.tags;
      if (
        this.storeFilterSource.length !== 0 ||
        this.storeFilterSkills.length !== 0 ||
        this.storeFilterAddedBy.length !== 0 ||
        this.storeFilterPositionID.length !== 0 ||
        this.storeFilterDate.length !== 0 ||
        this.storeFilterTags.length !== 0 ||
        this.storeCvsStatus !== null
      ) {
        this.filterApplied = true;
      }
    },
    cancelFilter() {
      this.filterObject.filterSource = this.storeFilterSource;
      this.filterObject.skillSets = this.storeFilterSkills;
      this.filterObject.createdByUserName = this.storeFilterAddedBy;
      this.filterObject.positionID = this.storeFilterPositionID;
      this.filterObject.cvsStatus = this.storeCvsStatus;
      this.filterObject.selectedDate = this.storeFilterDate;
      this.filterObject.tags = this.storeFilterTags;
      this.isFilter = false;
    },
    async showFilter() {
      await this.getNotes();
      if (this.isFilter) {
        this.isFilter = false;
      } else {
        this.filterObject.filterSource = this.storeFilterSource;
        this.filterObject.skillSets = this.storeFilterSkills;
        this.filterObject.createdByUserName = this.storeFilterAddedBy;
        this.filterObject.positionID = this.storeFilterPositionID;
        this.filterObject.cvsStatus = this.storeCvsStatus;
        this.filterObject.tags = this.storeFilterTags;
        this.filterObject.selectedDate = this.storeFilterDate;
        this.isFilter = true;
      }
    },
    closeKanbanFilter() {
      this.isFilter = false;
    },
    closeMultipleTrigger() {
      this.showMultiTrigger = false;
    },
    handleAddCandidates(newVal) {
      this.addMultipleCandidates = newVal;
    },
    handleCloseMultple(newVal) {
      this.checkMultiple = newVal;
    },
    handleAdd(newVal) {
      this.addMultipleCandidates = newVal;
    },
    handleTalentPoolClose(val) {
      this.showTalentPool = false;
      if (val == "candadded") {
        this.getParticularJob(this.$route.query.jobID);
        if (!this.vendor) this.getAllApplications(true);
      }
    },
    // display card details starts
    clearAllValues() {
      this.selectedID = "";
      this.isSchedule = false;
    },
    async getParticularJob(jobID) {
      this.clearAllValues();
      let payload = {
        type: 2,
        jobID: jobID,
        lead: this.customerDetail.lead,
      };
      if (this.vendor) {
        payload.lead = false;
      }
      const res = await getSingleJob(payload);
      if (res.status == 200) {
        this.particularJob = res.data.data;
        if (this.particularJob.status == 3 && !this.particularJob.closed) {
          this.interviewProcess = this.vendor
            ? this.particularJob.interviewProcess.process
            : this.particularJob.interviewProcess.process.filter(
                (obj) => obj.id != 0
              );
          if (this.vendor) {
            let current = this.particularJob.vendor.find(
              (obj) => obj.vendorID == this.$route.params.vendorID
            );
            this.vendorRounds = current.noOfRoundsToTake;
            this.candidatesToPush = current.noOfCandidatesToPush;
            this.interviewProcess = this.interviewProcess.filter(
              (obj) =>
                (typeof obj.id == "number" && obj.id <= this.vendorRounds) ||
                typeof obj.id == "string"
            );
            if (this.vendorRounds == 0) {
              this.interviewProcess = this.interviewProcess.filter(
                (obj) => !["H", "R"].includes(obj.id)
              );
            }
            this.interviewProcess.forEach((process) => {
              if (process.id == "F") {
                process.id = "P";
              }
            });
          } else {
            this.positionIDs = this.particularJob.positionInfo
              .filter((obj) => obj.status == 1)
              .map((obj) => {
                return obj.positionID;
              });
          }
          for (var i in this.interviewProcess) {
            this.showLoader[i] = true;
            this.pages[i] = 0;
            this.totals[i] = 0;
            this.pageEnds[i] = 0;
            this.spinners[i] = false;
            this.topSpinners[i] = false;
            if (this.interviewProcess[i].type == "assesment") {
              if (!this.uniqueFilter[this.interviewProcess[i].id]) {
                this.uniqueFilter[this.interviewProcess[i].id] = {
                  showFilter: false,
                  filterType: "0",
                  testID: "",
                  dateRange: [],
                  filterApplied: false,
                };
              }
              this.filterTestID.push("");
              this.filterDate.push("");
              this.storeUniqueValues.push("0");
            } else {
              this.filterDate.push("");
              this.storeUniqueValues.push("0");
              if (!this.uniqueFilter[this.interviewProcess[i].id]) {
                this.uniqueFilter[this.interviewProcess[i].id] = {
                  showFilter: false,
                  filterType: "0",
                  testID: "",
                  dateRange: [],
                  filterApplied: false,
                };
              }
            }
          }

          if (this.vendor) this.getAllRoundDetails("vendor");
          else {
            this.getAllRoundDetails("recruiter");
          }
        }
        this.loaderStatus = false;
      }
    },
    async getAllRoundDetails(val) {
      for (var i in this.interviewProcess) {
        let level =
          typeof this.interviewProcess[i].id != "string"
            ? JSON.stringify(this.interviewProcess[i].id)
            : this.interviewProcess[i].id;
        val == "recruiter"
          ? await this.getCandidates(level, i)
          : await this.getcandidateVendorJd(level, i);
      }
    },
    async refreshKanban() {
      // Reset all round pages to 0 so data is re-fetched from the beginning
      for (var i in this.interviewProcess) {
        this.pages[i] = 0;
        this.pageEnds[i] = 0;
        this.showLoader[i] = true;
        this.spinners[i] = false;
        this.topSpinners[i] = false;
        if (this.vendor) {
          this.loadedPages[i] = [];
        }
      }
      this.$forceUpdate();
      // Reload all kanban columns — per-column filters (storeUniqueValues, filterDate,
      await this.getAllApplications(true);
      await this.getAllRoundDetails("recruiter");
    },
    async getcandidateVendorJd(level, index, scroll, candEmails) {
      if (!this.loadedPages) this.loadedPages = {};
      if (!this.loadedPages[index]) this.loadedPages[index] = [];
      let payload = {
        page: this.pages[index],
        count: 10,
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
        vendorID: this.$route.params.vendorID,
        sortBy: {
          column: "updatedAt",
          order: -1,
        },
        level: level,
        filters: {
          skillSets: this.filterObject.skillSets,
          source: this.filterObject.filterSource,
          assessment_state:
            this.interviewProcess[index].type == "assesment"
              ? this.storeUniqueValues[index]
              : "",
          addedBy: "",
          scheduled:
            this.interviewProcess[index].type == "f2f"
              ? this.storeUniqueValues[index]
              : "",
          testID:
            this.interviewProcess[index].type == "assesment"
              ? this.filterTestID[index]
              : "",
          dateRange:
            this.filterDate[index] && this.filterDate[index].length != 0
              ? this.filterDate[index]
              : [],
          noOfTriggers: "",
          ...(this.interviewProcess[index].id == "F" && {
            selectionFilter:
              this.storeUniqueValues[index] &&
              this.storeUniqueValues[index] !== "0"
                ? this.storeUniqueValues[index]
                : "",
          }),
        },
        searchQuery: this.searchQuery,
      };
      if (
        candEmails &&
        this.interviewProcess[index].type == "assesment" &&
        ["5", "6"].includes(this.storeUniqueValues[index])
      ) {
        payload.filters.assessment_state = "0";
        payload.emailIDs = candEmails;
      }
      if (payload.filters.scheduled == 0) payload.filters.scheduled = "";
      if (this.filterObject.selectedDate.length != 0) {
        payload.filters.startDate = this.formatYearsDate(
          this.filterObject.selectedDate[0]
        );
        payload.filters.endDate = this.formatYearsDate(
          this.filterObject.selectedDate[1]
        );
      }
      const res = await getVendorCandidates(payload);
      if (res.status == 200) {
        if (this.loadedPages[index])
          this.loadedPages[index].push(this.pages[index]);
        if (!this.roundDetails[`round${level}`]) {
          this.roundDetails[`round${level}`] = { candidates: [] };
        }
        const candidates = await res.data.data.data;
        if (!scroll) {
          this.roundDetails[`round${level}`]["candidates"] = candidates;
          this.setTotalVendorData(index, level, res);
          this.$forceUpdate();
        } else {
          // Merge and deduplicate candidates
          const existingCandidates =
            this.roundDetails[`round${level}`]["candidates"];
          const mergedCandidates =
            scroll == "up"
              ? [...candidates, ...existingCandidates]
              : [...existingCandidates, ...candidates];
          const maxItems = 30;
          if (mergedCandidates.length > maxItems) {
            if (scroll == "up") {
              mergedCandidates.splice(-10);
            } else {
              this.scrollSlightlyUp(index);
              mergedCandidates.splice(0, 10);
              this.$forceUpdate();
            }
          }
          setTimeout(() => {
            this.roundDetails[`round${level}`]["candidates"] = mergedCandidates;
            if (scroll == "up") this.scrollToBottom(index);
            this.setLoadedPages(index, scroll);
            this.setTotalVendorData(index, level, res);
            this.$forceUpdate();
          }, 600);
        }
      } else {
        this.showLoader[index] = false;
        this.$forceUpdate();
      }
    },
    formatYearsDate(dateString) {
      return formatYearsDate(dateString);
    },
    setTotalVendorData(index, level, res) {
      if (level == "P") {
        this.totalPushed = res.data.data.totalPushed;
      }
      this.pageEnds[index] = res.data.data.pageEnd;
      this.totals[index] = res.data.data.total;
      this.spinners[index] = false;
      this.topSpinners[index] = false;
      this.showLoader[index] = false;
    },
    setLoadedPages(index, scroll) {
      const minPage = Math.min(...this.loadedPages[index]);
      const maxPage = Math.max(...this.loadedPages[index]);
      if (maxPage - minPage >= 3) {
        if (scroll == "up") {
          const pageIndex = this.loadedPages[index].indexOf(maxPage);
          if (pageIndex > -1) {
            this.loadedPages[index].splice(pageIndex, 1); // Remove the maxPage
          }
        } else {
          const pageIndex = this.loadedPages[index].indexOf(minPage);
          if (pageIndex > -1) {
            this.loadedPages[index].splice(pageIndex, 1); // Remove the minPage
          }
        }
      }
      this.loadedPages[index] = [...new Set(this.loadedPages[index])].sort();
    },
    async getCandidates(level, index, candEmails) {
      let payload = {
        page: this.pages[index],
        count: 10,
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
        sortBy: {
          column: "updatedAt",
          order: -1,
        },
        level: level,
        filters: {
          skillSets: this.filterObject.skillSets,
          source: this.filterObject.filterSource,
          assessment_state:
            this.interviewProcess[index].type == "assesment"
              ? this.storeUniqueValues[index]
              : "",
          addedBy: this.filterObject.createdByUserName,
          positions: this.filterObject.positionID,
          scheduled:
            this.interviewProcess[index].type == "f2f"
              ? this.storeUniqueValues[index]
              : "",
          testID:
            this.interviewProcess[index].type == "assesment"
              ? this.filterTestID[index]
              : "",
          noOfTriggers: "",
          dateRange:
            this.filterDate[index] && this.filterDate[index].length != 0
              ? this.filterDate[index]
              : [],
          tags: this.filterObject.tags,
          ...(this.interviewProcess[index].id == "F" && {
            selectionFilter:
              this.storeUniqueValues[index] &&
              this.storeUniqueValues[index] !== "0"
                ? this.storeUniqueValues[index]
                : "",
          }),
        },
        searchQuery: this.searchQuery,
        userType: this.customerDetail.lead ? "Lead Recruiter" : "Recruiter",
      };
      if (
        candEmails &&
        this.interviewProcess[index].type == "assesment" &&
        ["5", "6"].includes(this.storeUniqueValues[index])
      ) {
        payload.filters.assessment_state = "0";
        payload.emailIDs = candEmails;
      }
      if (payload.filters.scheduled == 0) payload.filters.scheduled = "";
      if (
        this.filterObject.cvsStatus != "3" &&
        this.filterObject.cvsStatus != null
      ) {
        payload.filters.cvsStatus = this.filterObject.cvsStatus;
      }
      if (this.filterObject.selectedDate.length != 0) {
        payload.filters.startDate = this.formatYearsDate(
          this.filterObject.selectedDate[0]
        );
        payload.filters.endDate = this.formatYearsDate(
          this.filterObject.selectedDate[1]
        );
      }
      const res = await getRoundDetails(payload);
      if (res.status == 200) {
        if (this.pages[index] == 0) {
          this.roundDetails[`round${level}`] = {
            candidates: [],
          };
          this.roundDetails[`round${level}`]["candidates"] = res.data.data.data;
        } else {
          this.roundDetails[`round${level}`]["candidates"] = [
            ...this.roundDetails[`round${level}`]["candidates"],
            ...res.data.data.data,
          ];
        }
        this.pageEnds[index] = res.data.data.pageEnd;
        this.totals[index] = res.data.data.total;
        this.spinners[index] = false;
        if (level === "F") await this.getCandRanking();
      }
      this.showLoader[index] = false;
      this.$forceUpdate();
    },
    displayTotal(index) {
      if (this.totals[index] < 9) {
        return "0" + this.totals[index];
      }
      return this.totals[index];
    },
    getColHeading(process) {
      var name;
      if (process.type) {
        name = process.type;
      } else {
        name = process.name;
      }
      let heading;
      switch (name) {
        case "Added to JD":
          heading = "Added to job";
          break;
        case "f2f":
          heading = "Face to Face";
          break;
        case "assesment":
          heading = "Assessment";
          break;
        case "Selected":
          heading = this.vendorRounds != null ? "Share to Client" : "Selected";
          break;
        case "Rejected":
          heading = "Rejected";
          break;
        case "On Hold":
          heading = "On Hold";
          break;
        case "Not Interested":
          heading = "Not Interested";
          break;
        default:
          heading = "";
      }
      return heading;
    },
    getRoundSrc(id) {
      let src;
      switch (id) {
        case "R":
          src = require("../../assets/img/newkanban/mainrejected.svg");
          break;
        case "P":
          src = require("../../assets/img/newkanban/mainselected.svg");
          break;
        case "F":
          src = require("../../assets/img/newkanban/mainselected.svg");
          break;
        case "NI":
          src = require("../../assets/img/newkanban/mainni.svg");
          break;
        case "H":
          src = require("../../assets/img/newkanban/mainonhold.svg");
          break;
        default:
          src = "";
      }
      return src;
    },
    checkRoundAssessment(val) {
      return (
        this.interviewProcess[val]?.type &&
        this.interviewProcess[val].type == "assesment"
      );
    },
    selCandidate(data) {
      this.selectedID = data;
    },
    async onScrollcandidates(index, process, event) {
      const { target } = event;
      let level =
        typeof process.id !== "string"
          ? JSON.stringify(process.id)
          : process.id;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.pageEnds[index], 0, this.totals[index]) &&
          !this.spinners[index] &&
          !this.topSpinners[index]
        ) {
          this.spinners[index] = true;
          this.$forceUpdate();
          if (this.vendor) {
            let pageFinal = this.loadedPages[index].length - 1;
            this.pages[index] = this.loadedPages[index][pageFinal] + 1;
            this.getcandidateVendorJd(level, index, "down");
          } else {
            this.pages[index] += 1;
            this.getCandidates(level, index);
          }
        }
        return;
      }

      // Upward Scrolling
      else if (
        this.vendor &&
        Math.ceil(target.scrollTop) === 0 &&
        !this.topSpinners[index] &&
        !this.spinners[index]
      ) {
        // Calculate next page to prepend
        const lowestPageFetched = Math.min(
          ...this.loadedPages[index],
          Infinity
        );
        let pageToFetch = lowestPageFetched - 1;

        // Prevent underflow or redundant fetching
        if (pageToFetch < 0 || this.loadedPages[index].includes(pageToFetch)) {
          return;
        }

        this.topSpinners[index] = true;
        this.$forceUpdate();
        this.pages[index] = pageToFetch;
        // Fetch candidates for upward scrolling
        if (this.vendor) {
          this.getcandidateVendorJd(level, index, "up");
        } else {
          this.getCandidates(level, index, true);
        }
      }
    },
    // job card dropdown start
    async toggleJobCard() {
      if (this.isJobDropdown) {
        this.isJobDropdown = !this.isJobDropdown;
      } else {
        this.jobPage = 0;
        this.showJobSpinner = false;
        if (this.vendor) {
          this.getVendorJobs();
          this.isJobDropdown = true;
        } else {
          await this.getJobs();
          this.isJobDropdown = true;
        }
      }
    },
    async getVendorJobs() {
      try {
        let payload = {
          searchQuery: "",
          page: this.jobPage,
          count: 10,
          sortBy: "updatedAt",
          order: "-1",
          vendorID: this.$route.params.vendorID,
        };
        const response = await getVendorJd(payload);
        if (response.status == 200) {
          if (this.jobPage == 0) {
            this.jobCards = response.data.data.data;
          } else {
            this.jobCards = [...this.jobCards, ...response.data.data.data];
          }
          this.jobTotal = response.data.data.total;
          this.jobPageEnd = response.data.data.pageEnd;
          this.showJobSpinner = false;
          // if (res.data.data.total == res.data.data.pageEnd) {
          //   this.showJobSpinner = false;
          // } else {
          //   this.showJobSpinner = true;
          // }
          // this.isJobDropdown = true;
        }
      } catch (error) {
        this.LoaderStatus = false;
        return error;
      }
    },
    goToCVSearch(comp) {
      this.$store.commit("cvSearchVUEX/setJobIDs", [this.$route.query.jobID]);
      this.$store.commit("cvSearchVUEX/setWhereFrom", "kanban");
      this.$router.push({
        name: "cvSearchKanban",
        query: {
          jobID: this.$route.query.jobID,
          cardName: this.$route.query.cardName,
          customerID: this.$route.query.customerID,
        },
        params: {
          component: comp,
        },
      });
    },
    async getJobs() {
      let payload = {
        type: "1",
        customerID: this.particularJob.customerID,
        sortBy: "updatedAt",
        order: "-1",
        searchQuery: "",
        status: "3",
        page: this.jobPage,
        count: 10,
        lead: this.customerDetail.lead,
      };
      const res = await getSingleJob(payload);
      if (res.status == 200) {
        if (this.jobPage == 0) {
          this.jobCards = res.data.data.data;
        } else {
          this.jobCards = [...this.jobCards, ...res.data.data.data];
        }
        this.jobTotal = res.data.data.total;
        this.jobPageEnd = res.data.data.pageEnd;
        this.showJobSpinner = false;
        // if (res.data.data.total == res.data.data.pageEnd) {
        //   this.showJobSpinner = false;
        // } else {
        //   this.showJobSpinner = true;
        // }
        // this.isJobDropdown = true;
      }
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },

    async selectJobCard(job) {
      if (this.vendor) {
        this.$router.push({
          name: "VendorKanban",
          params: {
            client: this.$route.params.client,
            vendorID: this.$route.params.vendorID,
          },
          query: {
            jobID: job.jobID,
            clientName: this.$route.query.clientName,
            jobTitle: job.title,
            vendorID: this.$route.params.vendorID,
          },
        });
      } else {
        this.applyContainers = false;
        this.$router.push({
          name: "Kanban",
          query: {
            jobID: job.jobID,
            customerID: job.customerID,
            cardName: this.$route.query.cardName,
            itype: this.$route.query.itype,
          },
        });
      }
      if (!this.vendor) {
        this.closeTrigger();
        this.closeScreening();
        this.jobAnalytics = false;
        this.showElement = false;
        // await this.getAllApplications(true);
      }
      this.loadedPages = {};
      this.loaderStatus = true;
      this.selectedID = "";
      this.particularJob = {};
      this.roundDetails = {};
      this.viewCandidateModal = false;
      this.isSchedule = false;
      this.selectedCandidate = {};
      this.interviewProcess = [];
      this.showLoader = [];
      this.pages = [];
      this.totals = [];
      this.spinners = [];
      this.topSpinners = [];
      this.pageEnds = [];
      this.totalApplications = null;
      this.uniqueFilter = {};
      this.storeUniqueValues = [];
      this.filterTestID = [];
      this.filterDate = [];
      await this.clearfilter(true, job.jobID);
      if (!this.vendor) await this.getCreditsInfo();
      this.setPositionIDs();
    },
    setPositionIDs() {
      if (!this.vendor && this.particularJob.positionIDs) {
        this.positionFilters = [];
        this.particularJob.positionInfo.map((obj) => {
          let values = {};
          values.key = obj.positionID;
          values.label = obj.positionID;
          values.status = obj.status;
          this.positionFilters.push(values);
        });
      }
    },
    closeCancelMeeting() {
      this.selectedCandidate = {};
      this.showCancelMeeting = false;
    },
    cancelMeet(cand) {
      this.selectedID = "";
      this.selectedCandidate = cand;
      this.showCancelMeeting = true;
    },
    triggerMultiple(process, index) {
      if (!process && !index) {
        this.selectedProcess = this.interviewProcess[0];
      } else {
        this.selectedProcess =
          process.id == 0 ? this.interviewProcess[index + 1] : process;
      }
      this.level =
        !index && !process
          ? "0"
          : this.vendor
          ? index.toString()
          : (index + 1).toString();
      const seldate = this.selectedProcess.config.closeTestdt;
      let todayDate = new Date();
      if (new Date(seldate) < todayDate) {
        this.showExpired = true;
      } else {
        this.showMultiTrigger = true;
      }
    },
    onScrollJob(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.jobPageEnd, 0, this.jobTotal) &&
          !this.showJobSpinner
        ) {
          this.showJobSpinner = true;
          this.jobPage++;
          if (this.vendor) {
            this.getVendorJobs();
          } else {
            this.getJobs();
          }
        }
      }
    },
    showShareClientModal(candidate) {
      this.selectedID = "";
      this.shareCandidate = candidate;
      this.showShareToClient = true;
    },
    // job card dropdonw end
    // trigger assessment code starts
    triggerAssessModal(candidate, process, type) {
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.selectedProcess = process;
      if (type && type == "fromadd") {
        this.inAddedToJd = true;
      } else if (type && type == "fromaction") this.fromAction = true;
      else this.inAddedToJd = false;
      this.trigger = true;
    },
    closeTriggerModal() {
      this.toRound = null;
      this.recRemarks = "";
      this.inAddedToJd = false;
      this.fromAction = false;
      this.selectedCandidate = {};
      this.selectedProcess = {};
      this.trigger = false;
    },

    // trigger asssessmnet code ends

    // schedule modal starts
    scheduleModal(candidate, round) {
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.toRound =
        round && round != "fromaction" ? round.id.toString() : this.toRound;
      if (round && round == "fromaction") this.fromAction = true;
      this.isSchedule = true;
    },
    addAttachment(candidate) {
      this.showAddNote = false;
      this.selectedID = "";
      if (candidate) this.selectedCandidate = candidate;

      this.showAddAttachment = true;
    },

    closeAttachment() {
      this.showAttachmentInNote = false;
      this.uploadingResume = false;
      // if (!this.isSchedule) this.selectedCandidate = {};
      this.showAddAttachment = false;
    },
    closeAddNote() {
      this.showAttachmentInNote = false;
      // if (!this.isSchedule) this.selectedCandidate = {};
      this.showAddNote = false;
      this.noteTagData = {};
    },
    addAddNote(candidate) {
      this.uploadingResume = false;
      this.showAddAttachment = false;
      this.selectedID = "";
      if (candidate) this.selectedCandidate = candidate;
      this.showAddNote = true;
    },

    closeScheduleModal() {
      this.toRound = null;
      this.recRemarks = "";
      this.selectedCandidate = {};
      this.selectedProcess = {};
      this.inAddedToJd = false;
      this.fromAction = false;
      this.isSchedule = false;
    },
    // schedule modal ends

    // not interested modal starts
    notIntModal(candidate) {
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.isNotInterested = true;
    },
    closeNotinterestedModal() {
      this.isNotInterested = false;
      this.selectedCandidate = {};
    },
    // not interested modal ends

    // move to final start
    openMoveToFinal(cand) {
      this.selectedCandidate = cand;
      this.isMoveToFinal = true;
      this.isSchedule = false;
      this.trigger = false;
    },
    closeMoveToFinal() {
      this.isMoveToFinal = false;
      this.selectedCandidate = {};
    },

    // move to final end
    // reassign modal strats here
    async reAssignModal(candidate) {
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.isReassign = true;
    },

    closeAssignRec() {
      this.selectedCandidate = {};
      this.isScreening = false;
      this.isReassign = false;
    },

    // re assign modal ends here

    // give feedbackmodal strats
    giveFeedbackModal(candidate, process) {
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.selectedProcess = process;
      this.isGiveFeedback = true;
    },
    closeGiveFeedback() {
      this.selectedCandidate = {};
      this.selectedProcess = {};
      this.isGiveFeedback = false;
    },
    // give feedbackmodal ends

    // view candidate modal starts
    viewCandidate(candidate, showNote) {
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.showNoteTag = showNote ? true : false;
      this.openReportTab = false;
      this.viewCandidateModal = true;
    },
    viewCandidateReport(candidate) {
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.openReportTab = true;
      this.viewCandidateModal = true;
    },
    selectCand(cand) {
      if (this.showTalentPool) this.showTalentPool = false;
      if (this.showMultiTrigger) this.closeMultipleTrigger();
      this.selectedCandidate = cand;
      this.viewCandID = cand.candidateID;
      this.viewCandidateModal = true;
    },
    closeViewIcon(showNote) {
      if (showNote) this.hoverCand = this.selectedCandidate.candidateID;
      // this.selectedCandidate = {};
      this.viewCandID = "";
      this.viewCandidateModal = false;
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    // view candidate modal ends

    // unique filter starts
    handleClickOutside(event) {
      const filterMenus = document.querySelectorAll(".unique-filter-id");
      filterMenus.forEach((filterMenu) => {
        const filterId = filterMenu.getAttribute("data-filter-id");
        if (
          filterId &&
          !filterMenu.contains(event.target) &&
          !document
            .getElementsByClassName("mx-calendar")[0]
            ?.contains(event.target) &&
          !document
            .getElementsByClassName("mx-calendar")[1]
            ?.contains(event.target)
        ) {
          // If the click is outside the filter menu, hide it
          this.$set(this.uniqueFilter[filterId], "showFilter", false);
          this.$forceUpdate();
        }
      });
    },
    showUniqueFilter(process, index) {
      let value = this.storeUniqueValues[index];
      Object.keys(this.uniqueFilter).forEach((key) => {
        if (key != process.id) {
          this.uniqueFilter[key].showFilter = false;
        }
      });
      this.uniqueFilter[process.id].showFilter =
        !this.uniqueFilter[process.id].showFilter;
      this.uniqueFilter[process.id].filterType = value;
      this.uniqueFilter[process.id].testID = this.filterTestID[index];
      this.uniqueFilter[process.id].dateRange = this.filterDate[index];
      const filterMenu = document.querySelector(
        `.unique-filter-id-${process.id}`
      );
      if (filterMenu) {
        filterMenu.setAttribute("data-filter-id", process.id);
      }
      this.$forceUpdate();
    },
    resetUniqueFilter(process, index) {
      if (process.type == "assesment") {
        if (this.uniqueFilter[process.id].filterApplied) {
          let level =
            typeof process.id != "string"
              ? JSON.stringify(process.id)
              : process.id;
          this.showLoader[index] = true;
          this.storeUniqueValues[index] = "0";
          this.filterTestID[index] = "";
          this.filterDate[index] = "";
          if (this.vendor) {
            this.getcandidateVendorJd(level, index);
          } else {
            this.getCandidates(level, index);
          }
        }
        this.uniqueFilter[process.id] = {
          showFilter: false,
          filterType: "0",
          testID: "",
          dateRange: [],
          filterApplied: false,
        };
        this.filterTestID[index] = "";
        this.filterDate[index] = "";
        this.storeUniqueValues[index] = "0";
      } else {
        if (this.uniqueFilter[process.id].filterApplied) {
          let level =
            typeof process.id != "string"
              ? JSON.stringify(process.id)
              : process.id;
          this.showLoader[index] = true;
          this.filterDate[index] = "";
          this.storeUniqueValues[index] = "0";
          if (this.vendor) {
            this.getcandidateVendorJd(level, index);
          } else {
            this.getCandidates(level, index);
          }
        }
        this.filterDate[index] = "";
        this.storeUniqueValues[index] = "0";
        this.uniqueFilter[process.id] = {
          showFilter: false,
          filterType: "0",
          testID: "",
          dateRange: [],
          filterApplied: false,
        };
      }
      const filterMenu = document.querySelector(
        `.unique-filter-id-${process.id}`
      );
      if (filterMenu) {
        filterMenu.removeAttribute("data-filter-id");
      }
      this.$forceUpdate();
    },
    cancelUniqueFilter(process) {
      this.uniqueFilter[process.id].showFilter =
        !this.uniqueFilter[process.id].showFilter;
      const filterMenu = document.querySelector(
        `.unique-filter-id-${process.id}`
      );
      if (filterMenu) {
        filterMenu.removeAttribute("data-filter-id");
      }
      this.$forceUpdate();
    },
    async applyUniqueFilter(process, index) {
      this.pages[index] = 0;
      this.storeUniqueValues[index] = this.uniqueFilter[process.id].filterType;
      this.filterTestID[index] = this.uniqueFilter[process.id].testID;
      this.filterDate[index] = this.uniqueFilter[process.id].dateRange;
      this.uniqueFilter[process.id].showFilter =
        !this.uniqueFilter[process.id].showFilter;

      if (
        this.uniqueFilter[process.id].filterType === "0" &&
        (!this.uniqueFilter[process.id].testID ||
          this.uniqueFilter[process.id].testID === "") &&
        (!this.uniqueFilter[process.id].dateRange ||
          this.uniqueFilter[process.id].dateRange.length === 0)
      ) {
        this.uniqueFilter[process.id].filterApplied = false;
      } else {
        this.uniqueFilter[process.id].filterApplied = true;
      }
      let level =
        typeof process.id != "string" ? JSON.stringify(process.id) : process.id;
      this.showLoader[index] = true;
      const filterMenu = document.querySelector(
        `.unique-filter-id-${process.id}`
      );
      if (filterMenu) {
        filterMenu.removeAttribute("data-filter-id");
      }
      this.$forceUpdate();
      let candEmails;
      if (
        process.type == "assesment" &&
        ["5", "6"].includes(this.uniqueFilter[process.id].filterType)
      ) {
        candEmails = await this.getPassFailCands(process);
      }
      if (this.vendor) {
        await this.getcandidateVendorJd(level, index, null, candEmails);
      } else {
        await this.getCandidates(level, index, candEmails);
      }
    },

    // unique filter ends

    // history modal starts
    openHistoryModal(candidate) {
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.showHistoryModal = true;
    },

    storeCandidateData() {
      this.$store.commit(
        "jobDescriptionVUEX/setSelectedCandidate",
        this.selectedCandidate
      );
    },
    storeProcessData() {
      this.$store.commit(
        "jobDescriptionVUEX/setSelectedProcess",
        this.selectedProcess
      );
    },

    hideFeedbackhistory() {
      this.showHistoryModal = false;
      this.selectedCandidate = {};
    },

    // history modal ends

    // action modal starts

    openActionModal(candidate, process) {
      this.selectedCandidate = candidate;
      for (let i in this.selectedCandidate["customerID"]) {
        if (
          this.selectedCandidate["customerID"][i][this.particularJob.jobID] !=
          undefined
        ) {
          if (
            this.selectedCandidate["customerID"][i][this.particularJob.jobID]
              .level == "NI"
          ) {
            this.selectedCandidate.roundstatuslevel =
              this.selectedCandidate["customerID"][i][
                this.particularJob.jobID
              ].notInterestedInLevel;
            this.selectedCandidate.roundstatusname = "Not Interested";
          } else if (
            this.selectedCandidate["customerID"][i][this.particularJob.jobID]
              .level == "H"
          ) {
            this.selectedCandidate.roundstatuslevel =
              this.selectedCandidate["customerID"][i][
                this.particularJob.jobID
              ].onHoldInLevel;
            this.selectedCandidate.roundstatusname = "On Hold";
          } else if (
            this.selectedCandidate["customerID"][i][this.particularJob.jobID]
              .level == "R"
          ) {
            this.selectedCandidate.roundstatuslevel =
              this.selectedCandidate["customerID"][i][
                this.particularJob.jobID
              ].rejectInLevel;
            this.selectedCandidate.roundstatusname = "Rejected";
          }
        }
      }
      this.selectedProcess = process;
      this.actionModal = true;
    },
    closeActionModal() {
      this.selectedCandidate = {};
      this.selectedProcess = {};
      this.actionModal = false;
    },
    triggerAction(data, remarks) {
      this.selectedProcess = data;
      this.toRound = data.id;
      this.recRemarks = remarks;
      this.actionModal = false;
      if (data.type == "assesment") {
        this.triggerAssessModal(
          this.selectedCandidate,
          this.selectedProcess,
          "fromaction"
        );
      } else {
        this.scheduleModal(this.selectedCandidate, "fromaction");
      }
    },

    // action modal ends'

    // give onhold feedback start
    giveOnHoldFeedback(candidate, process) {
      this.selectedCandidate = candidate;
      this.selectedProcess = process;
      this.isGiveFeedback = true;
    },
    // give onhold feedback ends

    goToAddCandidate() {
      let query = {
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
        customerName: this.$route.query.cardName,
      };
      if (this.vendor) {
        query.client = this.$route.params.client;
        query.vendorID = this.$route.params.vendorID;
        query.clientName = this.$route.query.clientName;
        query.titleName = this.$route.query.titleName;
        query.jobTitle = this.$route.query.jobTitle;
        this.$router.push({
          name: "AddCandidateInVendor",
          query: query,
        });
      } else {
        this.$router.push({
          name: "AddCandidateInJD",
          query: query,
        });
      }
    },
    gotoViewDocs(candID) {
      let query = {
        jobID: this.particularJob.jobID,
        candidateID: candID,
        from: this.$route.name,
      };
      if (this.vendor) {
        query.vendorID = this.$route.query.vendorID;
        query.client = this.$route.params.client;
        query.jobTitle = this.$route.query.jobTitle;
      } else {
        query.customerID = this.$route.query.customerID;
      }
      this.$router.push({
        name: "viewRequiredCandidateDocs",
        query,
      });
    },
    shareclient(data) {
      this.shareType = data;
    },
  },
};

export default kanbanData;
